import {
  useInitializeOfflineData,
  useToast,
  useAuth,
  StoredDisclaimerProcedure
} from "duck";
import { useUpdateDisclaimerProcedureSettingMutation } from "requests";
import { FormValues } from "../../form/duck";

export const useRenameDisclaimerProcedureSetting = (
  procedure: StoredDisclaimerProcedure,
  onSuccess: () => void
) => {
  const { loadDisclaimers } = useInitializeOfflineData();
  const [{ user }] = useAuth();
  const toast = useToast({ status: "success" });
  const [rename] = useUpdateDisclaimerProcedureSettingMutation({
    ignoreResults: true
  });

  return (values: FormValues) =>
    rename({
      variables: {
        input: {
          _id: procedure._id,
          title: values.title,
          description: values.description
        }
      }
    }).then(data => {
      loadDisclaimers(user.organization?._id || 0);
      if (data) {
        onSuccess();
        toast({ description: "Procedure type is updated successfully." });
      }
    });
};
